<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-09-04 17:43:13
 * @LastEditors: HG
 * @LastEditTime: 2020-03-05 14:37:40
 -->
<template>
  <div class="container">
    <head-nav-bar title="预约挂号结果" :fixed="true" @click-left="toIndex" />
    <div class="mt-header-nav">
      <div class="">
        <div class="result">
          <van-icon
            name="passed"
            class="icon"
            style="position: relative;top: 0.18rem;"
            v-if="info.bookingStatus === 1"
          />
          <van-icon
            name="fail"
            class="icon"
            style="position: relative;top: 0.18rem;"
            v-else
          />
          <span style="margin-left:0.2rem;">{{ info.bookingStatusDesc }}</span>
        </div>
        <div class="kong"></div>
        <div style="text-align:center;padding: 0.3rem;">
          <div class="color-red" style="font-size:1rem;">
            {{ info.bookingNo }}
          </div>
          <div class="text-less">挂号凭证号</div>
        </div>
        <div class="kong"></div>
        <div class="box">
          <div class="label-title">订单信息</div>
          <cell-box style="padding: 0.3rem 0;">
            <!-- <cell-item label="订单编号：" :value="info.BillNo" /> -->
            <cell-item label="挂号医院：" :value="info.hospitalName" />
            <cell-item label="挂号科室：" :value="info.departmentName" />
            <cell-item label="挂号医生：" :value="info.doctorName" />
            <cell-item label="就诊日期：" :value="info.bookingDate" />
            <cell-item
              label="门诊类型："
              :value="info.doctorNoSourceTypeDesc"
            />
            <cell-item label="排队号数：" :value="info.sortIndex" />
            <cell-item label="医院地址：" :value="info.hospitalAddress" />
            <cell-item label="就诊地址：" :value="info.waitingAddress" />
            <cell-item label="挂号日期：" :value="info.createdTime" />
          </cell-box>
        </div>
        <div class="kong"></div>
        <div class="box">
          <div class="label-title">就诊人信息</div>
          <cell-box style="padding: 0.3rem 0;">
            <cell-item label="就诊人：" :value="info.cardholderName" />
            <!-- <cell-item label="证件号：" :value="info.IdCardNo" /> -->
            <cell-item label="手机号：" :value="info.phoneNoProtected" />
          </cell-box>
        </div>
        <div class="kong"></div>
        <van-notice-bar wrapable :scrollable="false">
          1.挂号成功后，请按时到医院就诊<br />
          2.如需取消挂号，请到“个人中心”－我的挂号“中操作取消
        </van-notice-bar>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Icon, NoticeBar } from "vant";
import { CellBox, CellItem } from "@/components/cell";

export default {
  name: "Confirm",
  components: {
    CellBox,
    CellItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar
  },

  data() {
    return {
      Id: "",
      info: {}
    };
  },

  created() {
    this.Id = this.$route.query.Id;
    if (this.Id) {
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      this.$post("Booking_Detaile", {
        Id: this.Id
      }).then(res => {
        this.info = res.data;
      });
    },
    toIndex() {
      this.$router.replace({ name: "index" });
    }
  }
};
</script>

<style lang="less" scoped>
.result {
  font-size: 0.5rem;
  text-align: center;
  padding: 0.5rem;
  .icon {
    font-size: 0.6rem;
    color: @green;
  }
}
</style>
